<template>
  <nuttrema-layout-page-content>

    <template v-if="token">
      <nuttrema-loader v-if="InstanceRegistrationPreCompletion.fetching" theme="full-overlay"></nuttrema-loader>

      <template v-else-if="InstanceRegistrationPreCompletion.error">
        <nuttrema-empty-result
          class="with-logo"
          icon="far fa-qrcode">
          <template slot="text">
            <h1>{{ $t('label.invalid_token') }}</h1>
            <h4>{{ $t('label.missing_token_help') }}</h4>
          </template>
        </nuttrema-empty-result>
      </template>

      <template v-else>
        <registration-thank-you-jumbotron>
          <h1>{{ $t('label.thank_you_for_your_purchase') }}</h1>
          <h4 v-if="preCompletionPass">{{ $t('label.type_in_basic_information_and_your_credentials') }}</h4>
        </registration-thank-you-jumbotron>

        <registration-completion
          :token="token"
          :InstanceRegistrationCompletion="InstanceRegistrationCompletion"
          :InstanceRegistrationPreCompletion="InstanceRegistrationPreCompletion"
          @submit="onRegistrationCompletion">
        </registration-completion>
      </template>
    </template>

    <template v-else>
      <nuttrema-empty-result
         class="with-logo"
         predefined-set="thank-you"
        :img-style="{ width: '70%', marginTop: '-10%' }">
      </nuttrema-empty-result>
    </template>

    <template slot="footer">
      <nuttrema-footer></nuttrema-footer>
    </template>
  </nuttrema-layout-page-content>
</template>

<script>
import { isNil, get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import RedirectLogged from 'components/mixins/redirect-logged';

import NuttremaFooter from 'components/ui/panels/nuttrema-footer';
import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';

import RegistrationThankYouJumbotron from 'components/ui/panels/nuttrema-jumbotron';

import RegistrationCompletion from './cmpt-registration-completion';


export default {
  name: 'page-create-instance-thank-you',
  mixins: [
    PageProps,
    RedirectLogged,
  ],
  props: {
    token: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaFooter,
    RegistrationCompletion,
    NuttremaLayoutPageContent,
    RegistrationThankYouJumbotron,
  },
  data() {
    return {
      email: null,
    };
  },
  computed: {
    ...mapGetters([
      'InstanceRegistrationCompletion',
      'InstanceRegistrationPreCompletion',
    ]),
    preCompletionPass() {
      return isNil(get(this.InstanceRegistrationPreCompletion, 'error'));
    },
  },
  methods: {
    ...mapActions([
      'ProceedInstanceRegistrationCompletion',
    ]),
    onRegistrationCompletion(payload) {
      this.ProceedInstanceRegistrationCompletion({ payload })
        .then(() => {
          const email = get(this.InstanceRegistrationCompletion, 'data.Person.email');
          const password = get(payload, 'password');

          console.log('ProceedInstanceRegistrationCompletion', email, password);

          if (email && password) {
            const data = { email, password };
            this.$auth.login({
              url: '/auth/login',
              data,
              rememberMe: false,
              fetchUser: true,
              success() {
                this.redirectLogin();
              },
              error() {},
            });
          }
        })
        .catch(() => {
          this.errorNotification();
        });
    },
  },
  // created() {
  //   if (!isNil(this.token)) {
  //     this.$store.dispatch('GetProceedInstanceRegistrationPreCompletion', { query: { token: this.token } });
  //   }
  // },
  // beforeDestroy() {
  //   this.$store.dispatch('ClearInstanceRegistrationPreCompletion');
  // },
};
</script>

<style lang="scss" scoped>
  .page-create-instance-step-three {
    display: flex;
    flex-grow: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance-thank-you/page-create-instance-thank-you.vue